
import AppLayout from "@/components/layout/AppLayout";
import TeamsList from "./components/TeamsList";

const GuardTeamsPage = () => {
  return (
    <AppLayout>
      <TeamsList />
    </AppLayout>
  );
};

export default GuardTeamsPage;
